import API from '@/services/api'
import { authService, logsService } from '@/services'
// import areIntervalsOverlappingWithOptions from 'date-fns/esm/fp/areIntervalsOverlappingWithOptions/index.js'

const TYPES = {
  LOGIN: 'LOGIN',
  LOGOUT: 'LOGOUT',
  SET_USERNAME: 'SET_USERNAME',
  SET_CNPJ: 'SET_CNPJ',
}

const state = () => ({
  token: null,
  userName: 'default',
  cnpj: null,
})

const getters = {
  getUserName: (state) => {
    return state.userName
  },
  getToken: (state) => {
    return state.token
  },
  getCNPJ: (state) => {
    return state.cnpj
  },
}

function publicAuthError (error) {
  const data = error && error.response && error.response.data
  return data && typeof data === 'object' ? data : error
}

const actions = {
  login ({ commit }, params) {
    return new Promise((resolve, reject) => {
      authService.login(params).then(({ data }) => {
        API.setToken(data.token)
        // CHAMA A MUTATION
        commit(TYPES.LOGIN, data)
        commit(TYPES.SET_USERNAME, data.name)
        commit(TYPES.SET_CNPJ, data)
        resolve(data)
      }).catch(error => {
        // logsService.logs({ alert: error.response || error })
        reject(publicAuthError(error))
      })
    })
  },

  logout ({ commit }) {
    commit(TYPES.LOGOUT)
  },

  recoverPassword (_, params) {
    return new Promise((resolve, reject) => {
      authService.recoverPassword(params).then(({ data }) => {
        resolve(data)
      }).catch(error => {
        logsService.logs({ alert: error.response || error })
        reject(publicAuthError(error))
      })
    })
  },

  changePassword (_, params) { // é necessário o _ para não ser usado o commit
    return new Promise((resolve, reject) => {
      authService.changePassword(params).then(({ data }) => {
        resolve(data)
      }).catch(error => {
        logsService.logs({ alert: error.response || error })
        reject(publicAuthError(error))
      })
    })
  },
}

const mutations = {
  [TYPES.LOGIN] (state, payload) {
    state.token = payload.token
  },

  [TYPES.LOGOUT] (state) {
    state.cnpj = null
    state.token = null
    state.userName = null
  },

  [TYPES.SET_USERNAME] (state, payload) {
    // ALTERAR O VALOR DO STATE
    state.userName = payload
  },
  [TYPES.SET_CNPJ] (state, payload) {
    state.cnpj = payload.CNPJ
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
